import { Rect } from '../../../platform/geom/Rect';
import { Sketch } from './Sketch';
import { SketchStroke } from './SketchStroke';

export const SketchLayout = (sketch: Sketch) => {

    const strokes = sketch.polarize(SketchStroke);
    const thickest = Math.max(...strokes.map(x => x.thickness * x.base));
    const base = Rect.fromPoints(strokes.flatMap(x => x.spine)).inflate(thickest * 2);

    const spines = strokes.map(x => ({
        id: x.id,
        path: x.spine,
        color: x.color,
    }));

    const paths = strokes.map(x => ({
        id: x.id,
        ...x.layout,
    }));

    const padding = Math.max(...strokes.map(x => x.thickness)) * 2;

    return { base, paths, spines, padding };
};

export type SketchLayout = ReturnType<typeof SketchLayout>;
